export interface TscRegionDto {
  aggregateId: string;
  name: string;
  defaultForCountries: string[];
  defaultEscalationPattern: string;
  createdBy?: string;
  createdAt?: string | Date;
  updatedBy?: string;
  updatedAt?: string | Date;
}

export interface TscSalesOrganizationDto {
  aggregateId: string;
  name: string;
  regions: string[];
  createdBy?: string;
  createdAt?: string | Date;
  updatedBy?: string;
  updatedAt?: string | Date;
}

export class TscRegionSto {
  aggregateId: string;
  name: string;
  defaultForCountries: string[] = [];
  defaultEscalationPattern: string;
  createdBy: string;
  createdAt: Date;
  updatedBy: string;
  updatedAt: Date;

  constructor(dto: TscRegionDto | TscRegionSto) {
    if (dto) {
      this.aggregateId = dto.aggregateId;
      this.name = dto.name;
      this.defaultForCountries = dto.defaultForCountries || [];
      this.defaultEscalationPattern = dto.defaultEscalationPattern || '';
      this.createdBy = dto.createdBy;
      this.createdAt = parseApiDate(dto.createdAt);
      this.updatedBy = dto.updatedBy;
      this.updatedAt = parseApiDate(dto.updatedAt);
    }
  }
}

export class TscSalesOrganizationSto {
  aggregateId: string;
  name: string;
  regions: string[] = [];
  createdBy: string;
  createdAt: Date;
  updatedBy: string;
  updatedAt: Date;

  constructor(dto?: TscSalesOrganizationDto | TscSalesOrganizationSto) {
    if (dto) {
      this.aggregateId = dto.aggregateId;
      this.name = dto.name;
      this.regions = dto.regions || [];
      this.createdBy = dto.createdBy;
      this.createdAt = parseApiDate(dto.createdAt);
      this.updatedBy = dto.updatedBy;
      this.updatedAt = parseApiDate(dto.updatedAt);
    }
  }
}

function parseApiDate(date: Date | string): Date {
  return typeof date === 'string' ? new Date(date) : date;
}
